import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { TimeScanTypeInsertRequest } from "./TimeScanTypeInsertRequest";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { TimeScanTypeUpdateRequest } from "./TimeScanTypeUpdateRequest";

@Injectable()
export class DataService_TimeScanTypeSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadTimeScanType(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadTimeScanType?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeInsert(parms: TimeScanTypeInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/TimeScanTypeInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/TimeScanTypeCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/TimeScanTypeDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeDelete(TimeScanTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/TimeScanTypeDelete?TimeScanTypeID=" + TimeScanTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeUpdate(parms: TimeScanTypeUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/TimeScanTypeUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
